<template>
    <div class="managingPeople hp100 bbox " v-loading="loading">

        <!-- 卡片视图 -->
        <el-card>
            <!-- 搜索-->
    
                <!-- <el-col>
                    <el-button plain class="add-column-btn bbox" @click="gotoDetail('')" type="primary"> <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
                </el-col> -->
                <el-col>
                    <div class="flex align-center  header-search-box">
                      <el-form :inline="true">
                        <el-form-item label="用户手机号:">
               <el-input placeholder="请输入" clearable style="width:180px" v-model="queryInfo.condition.orderPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="注册日期:">
                                           <el-date-picker
                style="width:216px"
                 value-format="yyyy-MM-dd"
       v-model="dateRange"
         clearable
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
             </el-form-item>
           <el-form-item label="状态:">
        <el-select style="width:120px" clearable v-model="queryInfo.condition.blackFlag" >
    <el-option
      label="正常"
      value="0">
    </el-option>
        <el-option
      label="拉黑"
      value="1">
    </el-option>
  </el-select>
                        </el-form-item>
           <el-button @click="search" style="background:#F59A23;color:#fff">
                          <i v-if="btnLoading" class="el-icon-loading"></i>
                          查询</el-button>
                      </el-form>
                    </div>
                </el-col>
            <!-- 用户列表区域 -->
			 <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
           v-loading="tableLoading"
             element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
                    :data="tableData"
                    border
                    fit
                    highlight-current-row
                    style="width: 100%"
                    @sort-change="sortChange"
            >
             <el-table-column label="序号" align="center"  type="index" >
                    </el-table-column>
                    <el-table-column label="下单手机号" align="center"  prop="orderPhone" >
                    </el-table-column>
                      <el-table-column label="注册日期" align="center"  >
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDt |dataFormat }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户状态" align="center"  >
                        <template slot-scope="scope">
                            <span style="color:#B0ADB4;font-weight:500" v-if="scope.row.blackFlag==1">黑名单</span>
                            <span style="color:#77B04C;font-weight:500" v-if="scope.row.blackFlag==0">正常</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="排队次数" align="center"  prop="排队次数" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.queueCount }}</span>
                        </template>
                    </el-table-column>
                <el-table-column
                        label="操作"
                        align="center"
                        class-name="small-padding fixed-width cz"
                >
                    <template slot-scope="scope">
                      <el-popconfirm
                      v-if="scope.row.blackFlag==0"
                       icon="el-icon-info"
  icon-color="red"
  title="确定拉黑该用户吗？"
  @confirm="doBlock(scope.row.id,'1')"
  @onConfirm="doBlock(scope.row.id,'1')"
>
 <span class="centerLine" slot="reference" style="cursor:pointer">拉黑</span>
</el-popconfirm>
     <el-popconfirm
       v-if="scope.row.blackFlag==1"
      icon="el-icon-info"
  icon-color="red"
  title="取消拉黑该用户吗？"
  @confirm="doBlock(scope.row.id,'0')"
  @onConfirm="doBlock(scope.row.id,'0')"
>
 <span class="centerLine" slot="reference" style="cursor:pointer">取消拉黑</span>
</el-popconfirm>

     <el-popconfirm
  title="确认删除该用户吗？"
  @confirm="deleteOne(scope.row.id)"
  @onConfirm="deleteOne(scope.row.id)"
>
  <span  slot="reference" class="deleteBtn">删除</span>
</el-popconfirm>
  
                    </template>
                </el-table-column>
            </el-table>
			 </el-row></el-scrollbar
        >
		</div>
            <div class="footerBox">
                <!-- 分页区域 -->
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.currPage"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading:true,
      dateRange:null,
      btnLoading:false,
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition:{
          merchantCode:localStorage.getItem('merchantCode'),
          orderPhone:'',
          blackFlag:""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
    };
  },
  created() {
    this.getListData();
    window.addEventListener('resize', this.getHeight)
  },
  mounted() {
    this.loading = false;

  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    doBlock(id,flag){
     this.$http.post('/merchantLineUser/update',{id,blackFlag:flag}).then(res=>{
      console.log(res,'=====')
      this.getListData()
     })
    },
    deleteOne(id){
      this.$http.post('/merchantLineUser/delete',{id}).then(res=>{
        console.log(res,'--------')
        if(res.data.code==200){
          this.$message({type:'success',message:'删除成功'})
        }else{
          this.$message.error(res.data.message)
        }
        this.getListData()
      })
    },
    //条件查询
    search(){
      this.btnLoading=true
        if(this.dateRange!=null){
        this.queryInfo.condition.startDt=this.dateRange[0]
        this.queryInfo.condition.endDt=this.dateRange[1]
     }else{
        this.queryInfo.condition.startDt=null
        this.queryInfo.condition.endDt=null
     }
    this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {

    },

     getListData() {
        // 获取列表
        this.tableLoading=true
      var that = this;
      that.$http.post("/merchantLineUser/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        that.tableLoading=false
        that.btnLoading=false
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
  },
};
</script>

<style lang="less" scoped>
    .textblue {
        color: #008eff;
    }
    .managingPeople {
    .el-card {
        height: calc(100vh - 114px);
        position: relative;
    .el-select > .el-input {
        width: 200px;
    }
    .header-search-box .header-search-input {
        width: 325px;
    }
    input::placeholder {
        font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
        width: 100%;
        font-size: 13px;
        background-color: transparent;
        color: #008eff;
        z-index: 102;
    }
    .footerBox {
        position: absolute;
        width: 100%;
        height: 78px;
        left: 20px;
        right: 20px;
        bottom: 0;
    }
    }
    }
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .centerLine{
  width: 50px;
  display: inline-block;
  text-align: right;
  padding-right: 6px;
  border-right: 1px solid #ccc;
  height: 16px;
  line-height: 16px;
}
/deep/ .cz>.cell>span{
  transform: translateX(-12px);
}
/deep/ .deleteBtn{
  color:#EC6B5D;
  cursor:pointer;
  margin-left: 6px;
}
</style>

